import axios from "axios";

export function getDrawing(id) {
  return axios({
    method: "get",
    url: `${CONFIG.DRAWING_SERVICE}/${id}/public`
  });
}

export function getAttendeeList(id) {
  return axios({
    method: "get",
    url: `${CONFIG.DRAWING_SERVICE}/${id}/attendees/public`
  });
}

export function getWinnerList(id) {
  return axios({
    method: "get",
    baseURL: `${CONFIG["DRAWING_SERVICE"]}/${id}/winners/public`,
    withCredentials: true
  });
}

export const DEFAULT_LIMIT = 2001;

export function getLimitedAttendeeListWithAllWinners({ drawingId, limit = DEFAULT_LIMIT }) {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      baseURL: `${CONFIG["DRAWING_SERVICE"]}/${drawingId}/winners/public`,
      withCredentials: true
    })
      .then(({ data: winners }) => {
        axios({
          method: "get",
          baseURL: `${CONFIG["DRAWING_SERVICE"]}/${drawingId}/attendees/public?limit=${limit}`,
          withCredentials: true
        })
          .then(({ data: attendees }) => {
            const data = [...attendees];
            winners.forEach(winner => {
              if (!attendees.find(attendee => winner.id === attendee.id)) {
                const idx = Math.floor(Math.random() * limit);
                data.splice(idx, 0, winner);
              }
            })
            resolve({ data });
          })
          .catch(reject);
      })
      .catch(reject);

  });
}
